import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Blueprints } from './components/Blueprints';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full min-h-full overflow-x-hidden bg-cream font-sans antialiased" data-id="element-0" data-mp="28tmg367fagyt">
      <MetaPixel data-id="element-1" data-mp="23vupqgmff2wq" />

      <Hero data-id="element-2" data-mp="23u9v6r043jyv" />

      <main data-id="element-3" data-mp="23utcq6luo6cd">
        <StatsBar data-id="element-4" data-mp="23v2tr4ox335x" />
        <BeforeAfter data-id="element-5" data-mp="23ti67z10skhk" />
        <PainPoints data-id="element-6" data-mp="3ikh8ubu2yx01" />
        <Blueprints data-id="element-7" data-mp="3iiwf2oflbi38" />
        <Bonuses data-id="element-8" data-mp="3ijfunyhrpue3" />
        <OfferStack data-id="element-9" data-mp="3ihv1ac76whht" />
        <Guarantee data-id="element-10" data-mp="3mlawd43m29se" />
        <Testimonials data-id="element-11" data-mp="3mkre1ma1tjdu" />
        <AboutAuthor data-id="element-12" data-mp="3mk84otygs3bf" />
        <FAQ data-id="element-13" data-mp="3mjg9hk8s47lo" />
        <FinalCTA data-id="element-14" data-mp="3mj6jhwnqi0fz" />
      </main>

      <footer className="w-full bg-ink px-4 py-9 pb-24 text-center sm:px-6" data-id="element-15" data-mp="3rbzmog3k10py">
        <p className="font-display text-[15px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-16" data-mp="5osn3wyp084">
          The Natural Veneer Blueprint™
        </p>
        <p className="mt-2 text-[12.5px] text-white/55" data-id="element-17" data-mp="2zmo4r67q0h12">© 2026 · All Rights Reserved.</p>
        <p className="mx-auto mt-4 max-w-xl text-[11.5px] leading-relaxed text-white/40" data-id="element-18" data-mp="33nges1of2pye">
          This is an educational and reference product. It does not replace hands-on clinical
          education, professional supervision, manufacturer instructions, or your own clinical
          judgment.
        </p>
      </footer>

      <FloatingCTA anchorId="hero-cta" data-id="element-19" data-mp="nvasltl5rjh6" />
      <PurchasePopup data-id="element-20" data-mp="sudoanf90dch" />
    </div>;
}